import { CIcon } from '~/icons/types'

export const ciArrowLeft: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M10.7 20a.999.999 0 0 1-.72-.31l-6.7-7a.8.8 0 0 1-.18-.27v-.06A1 1 0 0 1 3 12a1 1 0 0 1 .07-.35v-.06a.801.801 0 0 1 .18-.27l6.7-7a1 1 0 0 1 1.44 1.38L6.34 11H20a1 1 0 0 1 0 2H6.34l5.08 5.31a1 1 0 0 1 0 1.41 1 1 0 0 1-.72.28Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'arrow-left',
  type: 'regular'
}
